<div class="row mx-0">
  <div class="col-12 px-0">
    <h5 class="nmbcol">{{ 'Sellers.Products.AddTicket' | translate }}</h5>
    <form [formGroup]="stepForm" *ngIf="stepForm">
        <div class="row">
          <div class="col-12">
            <app-ticket [fieldObject]="controllers['Ticket']"
                        [fieldErrors]="formValidator.formErrors"
                        [formControlRef]="convertControls(controllers['Ticket'].fieldName)"
                        [productType]="productTypeId"
                        [isUpdate]="isUpdate"></app-ticket>
          </div>
        </div>
      <div class="cardbg-white my-3">
        <div class="row">
            <app-toggle [fieldObject]="controllers['is_buyer_info']"
                        [fieldErrors]="formValidator.formErrors"
                        [formControlRef]="convertControls(controllers['is_buyer_info'].fieldName)"
                        [productType]="productTypeId"
                        [isUpdate]="isUpdate"></app-toggle>
        </div>
      </div>

    </form>
  </div>
</div>
